// extracted by mini-css-extract-plugin
module.exports = {"loadingBar":"StartSequence_loadingBar__XbcRt","pinkText":"StartSequence_pinkText__1lYgC","fillColor":"StartSequence_fillColor__1QNLi"};